import React from 'react';

import { Group } from '@controlrooms/components';

/**
 * ResizableContentArea - Horizontal resizable container
 * Contains SidePanel (left) and MainTabContent (right)
 * Memoized to prevent re-render when children haven't changed
 */
export const ResizableContentArea = React.memo<{ children: React.ReactNode }>(({ children }) => {
  return (
    <Group orientation="horizontal" style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
      {children}
    </Group>
  );
});

ResizableContentArea.displayName = 'ResizableContentArea';
